import { StorageService } from './storage.service';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CommonApi } from './api/common.api';
import { CommonService } from './common.service';
import { ApiUrls, Constants } from 'src/app/config/constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CatalogueService {

  retailerCatalog: any;

  constructor(
    private commonApi: CommonApi,
    private commonService: CommonService,
    private storageService: StorageService,
    private http: HttpClient
  ) { }

  homegetProductsList(url: any) {
    return forkJoin({
      categoryData: this.commonApi.getCDNLink(url.categoryData),
    }).pipe(
      catchError((err) => this.errorHandler(err)),
      map(({ categoryData }) => ({
        categoryData,
      }))
    );
  }

  getmerchantListArray(category: any) {
    const url = environment.baseUrl + ApiUrls.stores + '/' + category;
    return this.commonApi.getDataByUrl(url);
  }

  getmerchantListArrayWithLatLon(lat: number, lon: number, category: any, distance: any): Promise<any> {
    category == undefined ? category = '' : category
    const url = `${environment.baseUrl + ApiUrls.stores}?category=${category}&distance=${distance}`;
    const headers = new HttpHeaders({
      'Lat': lat.toString(),
      'Lon': lon.toString(),
    });
    return this.http.get<any>(url, { headers }).toPromise();
  }

  async getStoreMetaData(lat: number, lon: number, shopId: string) {
    const url = `${environment.baseUrl + ApiUrls.storeMeta}?shopId=${shopId}`;
    const headers = new HttpHeaders({
      'Lat': lat.toString(),
      'Lon': lon.toString(),
    });
    return this.http.get<any>(url, { headers }).toPromise();
  }

  getmerchant(url: any) {
    return this.commonApi.getCDNLinkNoCache(url);
  }

  getSplashApi() {
    const url = environment.baseUrl + ApiUrls.splash;
    this.commonApi.getDataByUrl(url).subscribe((res: any) => {
      if (res && res.data && res.data.catalogue_meta) {
        const urls = { categoryData: res.data.catalogue_meta['categories'].url };
        const catVersion = +res.data.catalogue_meta.categories.version;
        const productVersion = +res.data.catalogue_meta.products.version;
        const microVersion = +res.data.catalogue_meta.microCategpries.version;
        const previousVersion = this.storageService.getItem(Constants.VERSION_CONTROL);
        if (catVersion + productVersion + microVersion > previousVersion) {
          this.homegetProductsList(urls).subscribe((data) => {
            if (data) {
              this.storageService.setItem(Constants.VERSION_CONTROL, catVersion + productVersion + microVersion);
            }
          });
        }
      }
    });
  }

  getCategories(categoriesData: any) {
    const url = `${environment.baseUrl + ApiUrls.catalog.category}?limit=${categoriesData.limit}&offset=${categoriesData.offset}&city=${categoriesData.city}`;
    return this.commonApi.getDataByUrl(url);
  }

  productSearchSuggestions(searchQuery: any) {
    const url = `${ApiUrls.catalog.elasticSearch.searchSuggestion}`
    return this.commonApi.postData(url, searchQuery);
  }

  elasticSearch(searchQuery: any) {
    const url = `${ApiUrls.catalog.elasticSearch.productSearch}`
    return this.commonApi.postData(url, searchQuery);
  }

  bulkUpdate(id: any, data: any) {
    return this.commonApi.updateProductDataById(ApiUrls.catalog.bulkUpdate.bulk_update + '/' + id, data);
  }

  getDataByShop(id: any) {
    return this.commonApi.getProductDataById(ApiUrls.catalog.bulkUpdate.getProductByShop + '/' + id);
  }

  addProduct(data: any) {
    return this.commonApi.postData(ApiUrls.catalog.customCatalog.add_product, data);
  }

  addCustomProduct(data: any) {
    return this.commonApi.postData(ApiUrls.catalog.customCatalog.customCatalogRequests, data);
  }

  getCustomRequests(shopId: number): Observable<any> {
    return this.commonApi.getData(`${ApiUrls.catalog.customCatalog.customCatalogRequestsByID}/${shopId}`);
  }

  getNewProductRequests(shopId: number, page: number, limit: number): Observable<any> {
    const params = {
      page: page.toString(),
      limit: limit.toString()
    };
    return this.commonApi.getData(`${ApiUrls.catalog.customCatalog.newProductRequestsByID}/${shopId}`, { params });
  }

  private errorHandler(err: any) {
    this.commonService.toast(err.error.errorMessage);
    return throwError(err);
  }
}
